<script>

import LDialog from "@/views/edu/edu-info/student-manager/components/l-dialog/l-dialog.vue";

export default {
	name: "InfoLeft",
	components: {LDialog},
	props: {
		oss: {
			type: String,
			default: "",
		},
		value: {
			student_gender: "",
			obj_school: "",
		},
		allInfo: {},
	},
	data() {
		return {
			gender: ["female.png", "male.png"],
			studentProfile: [
				{field: "学号", value: "student_no"},
				{field: "出生日期", value: "birthday"},
				{field: "民族", value: "nation_name"},
				{field: "所在校区", value: "school_name"},
				{field: "就读年级", value: "grade_name"},
				{field: "行政班", value: "class_name"},
				{field: "学习方向", value: "learning_direction"},
				{field: "专业方向", value: "major"},
				{field: "班主任", value: "teacher_name"},
				{field: "宿舍", value: "dormitory"},
				{field: "政治面貌", value: "political_outlook"},
				{field: "鸿鹄等级", value: "honghu_level"},
			],
			dialogVisible: false,
		};
	},
	methods: {
		onAllInformation() {
			this.dialogVisible = !this.dialogVisible;
		},
	},
};
</script>

<template>
	<div class="info-left-main">
		<div style="align-items: center;display: flex">
			<img :src="oss+'people.png'" alt="" style="width: 30.03rem;height: 27.6rem">
      <span style="width: 96rem;height: 34rem;font-weight: 600;font-size: 24rem;color: #1E3AA2;margin-left: 16rem">基础信息</span>
		</div>

    <div style="display: flex;margin-top: 24rem;position: relative;">
      <div class="fixed-title">
        <img class="fixed-img" :src="oss+'school.png'" alt="x">
        <span class="fixed-tips">目标大学</span>
        <span class="fixed-school">{{ value.obj_school }}</span>
      </div>
      <img class="info-img" v-if="allInfo.base.photo" :src="allInfo.base.photo" alt="" >
      <img class="info-img" v-else alt="" src="@/assets/img/default-header.png">
      <div style="padding-top:14rem;margin-left: 30rem;flex: 1">
        <div style="flex: 1;display: flex;align-items: end;height: 40rem;justify-content: space-between">
          <div>
            <span style="width: 72rem;height: 18rem;font-weight: 600;font-size: 24rem;color: #333333;">{{ value.student_name }}</span>
            <img :src="value.student_gender === '女' ? oss+gender[0] : oss+gender[1]" alt="" style="width: 20rem;height: 20rem;margin-left: 16rem">
          </div>
          <div class="title-more" @click="onAllInformation">
            更多信息<i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="info-box">
          <div class="info-item" v-for="(item, index) in studentProfile" :key="index">
            <div class="label" style="">{{ item.field }}</div>
            <div class="value" style="">{{ item.value === 'honghu_level' ? (value[item.value] || '-') : value[item.value] }}</div>
          </div>
        </div>
      </div>
    </div>

		<l-dialog :all-info="allInfo" :visible.sync="dialogVisible"></l-dialog>
	</div>
</template>

<style lang="scss" scoped>
.info-left-main {
  width: 1070rem;
  //min-height: 356rem;
	background: #FFF;
	border-radius: 8rem;
	box-sizing: border-box;
	padding: 24rem;
  .fixed-title {
    position: absolute;
    top: -40rem;
    right: -24rem;
    height: 40rem;
    padding: 0 24rem 0 16rem;
    font-size: 16rem;
    background: linear-gradient(270deg, #FF662C 0%, #FF9839 100%);
    border-radius: 8rem 0 0 8rem;
    display: flex;
    align-items: center;
  }
  .fixed-img {
    width: 24rem;
    height: 24rem;
  }
  .fixed-tips {
    color: #FFE4D5;
    margin-left: 6rem;
    margin-right: 10rem;
  }
  .fixed-school {
    font-weight: 600;
    color: #FFFFFF;
  }
  .title-more {
    font-size: 14rem;
    color: #888;
    cursor: pointer;
  }
  .info-img {
    width: 202rem;
    height: 264rem;
  }
  .info-box {
    margin-top: 14rem;
    padding: 20rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24rem;
    background-color: #F5F8FF;
    border-radius: 6rem;
  }
  .info-item {
    display: flex;
    min-height: 18rem;
    font-size: 14rem;
    .label {
      min-width: 80rem;
      height: 18rem;
      color: #888;
    }
    .label {
      min-height: 18rem;
      color: #3C3C3C;
    }
  }
}
</style>
